import React, { useState} from "react"
import { useForm } from "react-hook-form"
import { FormType } from "../../types"
import { trimmedGaCookieValue } from "../../../utils/look-up-ga-cookie"
import persistQueryParams from "../../../utils/persist-query-params"
import BrandedHybridLeadForm from "./branded-hybrid-lead-form"

type FormProps = {
  form: FormType
  [key: string]: any
}

type FormData = {
  zipCode: string
}

const BrandedHybridModalForm = ({ form, ...props }: FormProps) => {
  const { register, handleSubmit, formState: { errors } } = useForm()
  const [isModalOpen, setIsModalOpen] = useState(false) // State for modal visibility
  const [zipCode, setZipCode] = useState(``)
  const zipCodeClasses = `branded-hybrid-input mb-1 mx-auto block max-w-lg bg-inputBackground ${errors.zipCode ? `border-red-500` : ``}`
  const buttonClasses = `px-8 pb-1 min-w-50 text-white rounded-button text-3xl border-brandYellow border-4 font-medium`

  const onSubmit = (data: FormData) => {
    // GA event logging
    if (typeof marketingDataLayer !== `undefined`) {
      marketingDataLayer?.push({
        event: `gaForm`,
        eventCategory: `Form`,
        eventAction: `zip-form`,
        eventLabel: location.pathname
      });
    }

    // Tealium event logging
    if (typeof utag !== `undefined`) {
      console.log(`Tealium is loaded: ${trimmedGaCookieValue()}`)
      
      utag.link({
        "customer_birthdate"     : "",                  //Required
        "customer_email"         : "",                  //Required
        "customer_first_name"    : "",                  //Required
        "customer_id"            : trimmedGaCookieValue(), //Required (RTRIM value of _ga Cookie)
        "customer_last_name"     : "",                  //Required
        "customer_name"          : "",                  //Required
        "customer_phone_number"  : "",                  //Required
        "customer_postal_code"   : `${data.zipCode}`,   //Required
        "customer_state"         : "",                  //Required
        "customer_type"          : "",                  //Required
        "form_id"                : "",                  //Required
        "form_name"              : "Branded Hybrid Zip Form",          //Required
        "tealium_event"          : "form_complete"      //Required
      });
    }
    else {
      console.log(`Tealium is NOT loaded: ${trimmedGaCookieValue()}`)
    }

    setZipCode(data.zipCode)
    setIsModalOpen(true)
    //location.assign(`${form.destination}?${search}`)
  }

  // On load, focus the form
  React.useEffect(() => {
    
  }, [])

  return (
    <>
        <form id="zip-form" onSubmit={handleSubmit(onSubmit)}>
            <input
                {...register("zipCode", { required: true, maxLength: 5, minLength: 4 })}
                type="number"
                className={zipCodeClasses}
                placeholder="Enter Zip Code"
                autoComplete="postal-code"
                autoFocus
            />

            <div className="text-center mt-5">
                {Object.keys(errors).length > 0 && (
                <div className="bg-red-400 p-3 my-10 text-white rounded">A 4 or 5 digit zip code is required</div>
                )}

                <button type="submit" className={buttonClasses}>
                {form.submitText || `Submit`}
                </button>
            </div>
        </form>

        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} zipCode={zipCode}>
            <h3 className="text-primary font-normal mt-0 mb-0 sm:mb-2 text-center text-2xl md:text-3xl">You're Almost There!</h3>
            <p className="mb-2 md:mb-8 text-primary text-center font-light text-md hidden md:block">Help us get more <span className="underline-red">accurate results.</span></p>
            <BrandedHybridLeadForm form={form} zipCode={zipCode} />
        </Modal>
    </>
  )
}

// Simple Modal Component
const Modal: React.FC<{ isOpen: boolean; onClose: () => void; zipCode: string }> = ({ isOpen, onClose, children, zipCode }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-3xl shadow-lg p-6 w-11/12 max-w-2xl relative border-2 border-gray-700">
        <button
          onClick={onClose}
          className="absolute bg-white p-0.5 top-2 right-2 text-primary focus:outline-none rounded-full border-2 border-solid border-primary"
          aria-label="Close Modal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {children}
      </div>
    </div>
  )
}

export default BrandedHybridModalForm
